export default __webpack_public_path__ + "static/media/music_icons.0dcb24a9.webp";